<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 mb-1 text-primary font-weight-bold">Top Banners</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Top Banner</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Name"
            label-for="input-1"
          >
            <input
              v-model="name"
              v-validate="'required'"
              name="name"
              data-vv-as="Name"
              placeholder="Name"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Banner Image URL WebP (Desktop)"
            label-for="input-1"
          >
            <!-- <input
              v-model="fileDesktop"
              v-validate="'required'"
              name="fileDesktop"
              data-vv-as="Url Image Desktop"
              placeholder="Url Image Desktop"
              class="form-control"
            /> -->
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Desktop)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1920px x 700px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktop"
                    name="fileDesktop"
                    data-vv-as="Image Desktop WebP"
                    v-validate="'required|minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:webp'"
                    style="display: none"
                    v-on:change="onChangeFileDesktop()"
                  />
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="!fileDesktop"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="fileDesktop"
                    variant="primary"
                    @click="modalDesktop = !modalDesktop"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="fileDesktop"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('fileDesktop') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Banner Image URL WebP (Mobile)"
            label-for="input-1"
          >
            <!-- <input
              v-model="fileMobile"
              v-validate="'required'"
              name="fileMobile"
              data-vv-as="Url Image Mobile"
              placeholder="Url Image Mobile"
              class="form-control"
            /> -->
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Mobile)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(640px x 600px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobile"
                    name="fileMobile"
                    data-vv-as="Image Mobile WebP"
                    v-validate="'required|minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:webp'"
                    style="display: none"
                    @change="onChangeFileMobile()"
                  />
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="!fileMobile"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="fileMobile"
                    variant="primary"
                    @click="modalMobile = !modalMobile"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="fileMobile"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('fileMobile') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Banner Image URL JPG (Desktop)"
            label-for="input-1"
          >
            <!-- <input
              v-model="fileDesktopJPG"
              v-validate="'required'"
              name="fileDesktop"
              data-vv-as="Url Image Desktop"
              placeholder="Url Image Desktop"
              class="form-control"
            /> -->
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Desktop)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1920px x 700px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktopJPG"
                    name="fileDesktopJPG"
                    data-vv-as="Image Desktop JPG"
                    v-validate="'required|minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,gif,jpeg,svg'"
                    style="display: none"
                    v-on:change="onChangeFileDesktopJPG()"
                  />
                  <b-button
                    @click="$refs.fileDesktopJPG.click()"
                    v-show="!fileDesktopJPG"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="fileDesktopJPG"
                    variant="primary"
                    @click="modalDesktopJPG = !modalDesktopJPG"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileDesktopJPG.click()"
                    v-show="fileDesktopJPG"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('fileDesktopJPG') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Banner Image URL JPG (Mobile)"
            label-for="input-1"
          >
            <!-- <input
              v-model="fileMobileJPG"
              v-validate="'required'"
              name="fileMobile"
              data-vv-as="Url Image Mobile"
              placeholder="Url Image Mobile"
              class="form-control"
            /> -->
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Mobile)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(640px x 600px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobileJPG"
                    name="fileMobileJPG"
                    data-vv-as="Image Mobile JPG"
                    v-validate="'required|minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:jpg,png,gif,jpeg,svg'"
                    style="display: none"
                    @change="onChangeFileMobileJPG()"
                  />
                  <b-button
                    @click="$refs.fileMobileJPG.click()"
                    v-show="!fileMobileJPG"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="fileMobileJPG"
                    variant="primary"
                    @click="modalMobileJPG = !modalMobileJPG"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMobileJPG.click()"
                    v-show="fileMobileJPG"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('fileMobileJPG') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (Bahasa)"
            label-for="input-1"
          >
            <input
              v-model="title_id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Heading Bahasa"
              placeholder="Heading in Bahasa"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (English)"
            label-for="input-1"
          >
            <input
              v-model="title_en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Heading English"
              placeholder="Heading in English"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (Bahasa)"
            label-for="input-1"
          >
            <textarea
              id="textarea"
              v-model="sub_title_id"
              v-validate="'required'"
              name="sub_title_id"
              data-vv-as="Sub Heading Bahasa"
              placeholder="Sub Heading in Bahasa..."
              rows="3"
              max-rows="6"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-sub_title_id-feedback"
            >{{ veeErrors.first('sub_title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (English)"
            label-for="input-1"
          >
            <textarea
              id="textarea"
              v-model="sub_title_en"
              v-validate="'required'"
              name="sub_title_en"
              data-vv-as="Sub Heading English"
              placeholder="Sub Heading in English..."
              rows="3"
              max-rows="6"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-sub_title_en-feedback"
            >{{ veeErrors.first('sub_title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="With Button" label-for="input-1">
            <b-form-radio-group
              id="radio-group-1"
              v-model="is_active"
              :options="options1"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="is_active">
        <br />
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Text (Bahasa)" label-for="input-1">
            <input
              :disabled="is_active == false"
              v-model="button_id"
              v-validate="'required'"
              data-vv-as="Button Text Bahasa"
              name="button_id"
              class="form-control"
              placeholder="Button Text in Bahasa"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('button_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Text (English)" label-for="input-1">
            <input
              :disabled="is_active == false"
              v-model="button_en"
              v-validate="'required'"
              data-vv-as="Button Text English"
              name="button_en"
              class="form-control"
              placeholder="Button Text in English"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('button_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row v-show="is_active">
        <br />
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Url" label-for="input-1">
            <b-form-radio-group
              id="radio-group-url"
              v-model="button_is_article"
              :options="options3"
              name="radio-url"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="is_active">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Article"
            label-for="input-1"
            v-show="button_is_article == true"
          >
            <vue-multiselect
              id="ajax2"
              open-direction="bottom"
              v-model="article_url"
              v-validate="button_is_article == true && is_active == true ? 'required':''"
              data-vv-as="Article Url"
              name="article_url"
              :preserve-search="true"
              :options="dataArticle"
              :custom-label="nameWithLang"
              placeholder="Type to search Article"
              track-by="id"
              label="slug"
              class="text-capitalize"
              :loading="isLoadingArticle"
              :searchable="true"
              @search-change="asyncFindArticle"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.title.id }}</span>
                </div>
              </template>
            </vue-multiselect>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('article_url') }}</p>
          </b-form-group>

          <b-form-group
            id="fieldset-1"
            label="Other URL"
            label-for="input-1"
            v-show="button_is_article == false"
          >
            <input
              v-model="button_url"
              v-validate="button_is_article == false && is_active == true ? 'required':''"
              name="button_url"
              data-vv-as="Other URL"
              class="form-control"
              placeholder="URL"
            />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('button_url') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="With Download Button" label-for="input-1">
            <b-form-radio-group
              id="download-button"
              v-model="is_with_download_button"
              :options="options1"
              name="download-button"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="is_with_download_button">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Play Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download Play Store</b>
                    <sup class="text-secondary pl-3">(2 Mb)&nbsp;(160px x 50px)</sup>
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="play_store_icon"
                      name="playstoreicon"
                      v-validate="is_with_download_button == true && is_active == true ? 'required|minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp':'minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp'"
                      style="display: none"
                      @change="onChangeFilePlayStore()"
                    />
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="!play_store_icon"
                      variant="primary"
                      class="ml-5"
                    >Select Icon</b-button>
                    <b-button
                      v-show="play_store_icon"
                      variant="primary"
                      @click="modalPlayStore = !modalPlayStore"
                      class="mr-2"
                    >Preview</b-button>
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="play_store_icon"
                      variant="outline-primary"
                      class
                    >Change File</b-button>
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('playstoreicon') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="App Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download App Store</b>
                    <sup class="text-secondary pl-3">(2 Mb)&nbsp;(160px x 50px)</sup>
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="app_store_icon"
                      name="appstoreicon"
                      v-validate="is_with_download_button == true && is_active == true ? 'required|minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp':'minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp'"
                      style="display: none"
                      @change="onChangeFileAppStore()"
                    />
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="!app_store_icon"
                      variant="primary"
                      class="ml-5"
                    >Select Icon</b-button>
                    <b-button
                      v-show="app_store_icon"
                      variant="primary"
                      @click="modalAppStore = !modalAppStore"
                      class="mr-2"
                    >Preview</b-button>
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="app_store_icon"
                      variant="outline-primary"
                      class
                    >Change File</b-button>
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('appstoreicon') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="play_store_url"
              v-validate="is_with_download_button == true && is_active == true ? 'required':''"
              data-vv-as="URL Play Store"
              name="play_store_url"
              class="form-control"
              placeholder="URL Play Store"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('play_store_url') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="app_store_url"
              v-validate="is_with_download_button == true && is_active == true ? 'required':''"
              data-vv-as="URL App Store"
              name="app_store_url"
              class="form-control"
              placeholder="URL App Store"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('app_store_url') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model="status"
              :options="options2"
              name="radio-status"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Period" label-for="input-1">
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Start Date"
                    v-model="period_start"
                    :format="customFormatter"
                    :disabled="is_always_active"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col class="pt-1 px-4 form-control del-calender-select border-left-0" md="2">
                    <b-row class="pt-1">
                      <b-col>
                        <b-link @click="resetStardate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form-group>
        </b-col>
        <b-col>
          <p class="mt-n2">&nbsp;</p>
          <b-form-group id="fieldset-1" label-for="input-1">
            <b-row class="m-0">
              <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
              </b-col>
              <b-col class="px-0">
                <datepicker
                  input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                  placeholder="End Date"
                  v-model="period_end"
                  :format="customFormatter"
                  :disabled="is_always_active"
                  :disabledDates="disabledDates"
                ></datepicker>
              </b-col>
              <b-col align="left" md="1" class="px-0">
                <b-col
                  align="left"
                  class="pt-1 px-4 form-control del-calender-select border-left-0"
                  md="2"
                >
                  <b-row align="left" class="pt-1">
                    <b-col>
                      <b-link @click="resetEnddate" style="text-decoration:none">
                        <i class="text-danger fas fa-times"></i>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <br />
      <b-row>
        <b-col align="right">
          <b-button
            variant="primary"
            @click="post()"
            :disabled="loading"
            class="mr-3"
            size="lg"
          >Create</b-button>
          <router-link :to="{name: 'homePage'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalMobile" title="Preview Image" size="xl">
      <img v-if="urlMobile" width height="400px" :src="urlMobile" />
    </b-modal>
    <b-modal v-model="modalDesktop" title="Preview Image" size="xl">
      <img v-if="urlDesktop" width height="400px" :src="urlDesktop" />
    </b-modal>
    <b-modal v-model="modalMobileJPG" title="Preview Image" size="xl">
      <img v-if="urlMobileJPG" width height="400px" :src="urlMobileJPG" />
    </b-modal>
    <b-modal v-model="modalDesktopJPG" title="Preview Image" size="xl">
      <img v-if="urlDesktopJPG" width height="400px" :src="urlDesktopJPG" />
    </b-modal>
    <b-modal v-model="modalPlayStore" title="Preview Image" size="xl">
      <img v-if="urlPlayStore" width height="400px" :src="urlPlayStore" />
    </b-modal>
    <b-modal v-model="modalAppStore" title="Preview Image" size="xl">
      <img v-if="urlAppStore" width height="400px" :src="urlAppStore" />
    </b-modal>
    <br />
    <br />
  </div>
</template>

<script>
import _ from "lodash";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      is_with_download_button: false,
      loading: false,
      widthMobile: null,
      heightMobile: null,
      widthDesktop: null,
      heightDesktop: null,
      name: null,
      title_id: null,
      title_en: null,
      sub_title_id: null,
      sub_title_en: null,
      article_url: null,
      button_url: null,
      button_id: null,
      button_en: null,
      status: "publish",
      is_active: false,
      InputImageMobile: false,
      InputImageDesktop: false,
      is_always_active: false,
      button_is_article: true,
      period_start: "",
      period_end: "",
      modalMobile: false,
      modalDesktop: false,
      modalMobileJPG: false,
      modalDesktopJPG: false,
      fileDesktop: "",
      fileDesktopJPG: "",
      fileMobile: "",
      fileMobileJPG: "",
      urlMobile: "",
      urlDesktop: "",
      urlMobileJPG: "",
      urlDesktopJPG: "",
      isLoadingArticle: false,
      searchTermArticle: "",
      modalPlayStore: false,
      modalAppStore: false,
      play_store_icon: "",
      play_store_url: "",
      app_store_icon: "",
      app_store_url: "",
      urlAppStore: "",
      urlPlayStore: "",
      dataArticle: [],
      options: [],
      options1: [
        { text: "No", value: false },
        { text: "Yes", value: true }
      ],
      options3: [
        { text: "Article", value: true },
        { text: "Other URL", value: false }
      ],
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" }
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      }
    };
  },
  beforeCreate() {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", 10);
    formData.append("page", 1);
    formData.append("status", "publish");
    formData.append("status", "highlight");
    this.$store
      .dispatch("ArticleModule/getArticles2", formData)
      .then(response => {
        this.dataArticle = response.data.data.results;
        this.isLoadingArticle = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.isLoadingArticle = false;
      });
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetStardate() {
      this.period_start = "";
    },
    resetEnddate() {
      this.period_end = "";
    },
    asyncFindArticle(query) {
      this.isLoadingArticle = true;
      this.searchTermArticle = query;
      this.getWorksAsync();
    },
    getWorksAsync: _.debounce(function() {
      const article = this.searchTermArticle.toLowerCase();
      const formData = new FormData();
      formData.append("search_param", article);
      formData.append("limit", 10);
      formData.append("page", 1);
      formData.append("status", "publish");
      formData.append("status", "highlight");
      this.$store
        .dispatch("ArticleModule/getArticles2", formData)
        .then(response => {
          this.dataArticle = response.data.data.results;
          this.isLoadingArticle = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.isLoadingArticle = false;
        });
    }, 1000),
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("image_desktop_webp", this.fileDesktop);
          formData.append("image_mobile_webp", this.fileMobile);
          formData.append("image_desktop_jpg", this.fileDesktopJPG);
          formData.append("image_mobile_jpg", this.fileMobileJPG);
          formData.append("name", this.name);
          formData.append("title_id", this.title_id);
          formData.append("title_en", this.title_en);
          formData.append("sub_title_id", this.sub_title_id);
          formData.append("sub_title_en", this.sub_title_en);
          formData.append("button_id", this.button_id);
          formData.append("button_en", this.button_en);
          formData.append(
            "is_with_download_button",
            this.is_with_download_button
          );
          formData.append("play_store_icon", this.play_store_icon);
          formData.append("play_store_url", this.play_store_url);
          formData.append("app_store_icon", this.app_store_icon);
          formData.append("app_store_url", this.app_store_url);

          formData.append("is_article", this.button_is_article);
          if (this.button_is_article && this.is_active) {
            formData.append("article_url", this.article_url.id);
            formData.append("slug", this.article_url.slug);
            formData.append("created_at_date_only", this.article_url.created_at);
          } else {
            formData.append("article_url", this.article_url);
            formData.append("slug", this.article_url);
            formData.append("created_at_date_only", this.article_url);
          }
          formData.append("button_url", this.button_url);
          formData.append("is_active", this.is_active);
          formData.append("is_always_active", this.is_always_active);
          if (this.period_start != "" && this.period_end == "") {
            const start = this.period_start.toJSON().slice(0, 10);
            formData.append("period_start", start);
            formData.append("period_end", this.period_end);
          }
          if (this.period_end != "" && this.period_start == "") {
            const end = this.period_end.toJSON().slice(0, 10);
            formData.append("period_start", this.period_start);
            formData.append("period_end", end);
          }
          if (this.period_start != "" && this.period_end != "") {
            const start = this.period_start.toJSON().slice(0, 10);
            const end = this.period_end.toJSON().slice(0, 10);

            formData.append("period_start", start);
            formData.append("period_end", end);
          }
          if (this.period_start == "" && this.period_end == "") {
            formData.append("period_start", this.period_start);
            formData.append("period_end", this.period_end);
          }
          formData.append("status", this.status);
          this.$store
            .dispatch("homePageModule/postHomepage", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "homePage" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeFileDesktop() {
      this.fileDesktop = this.$refs.fileDesktop.files[0];
      const input = this.$refs.fileDesktop;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthDesktop = img.width;
            this.heightDesktop = img.height;
          };
          img.src = e.target.result;
          this.urlDesktop = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobile() {
      this.fileMobile = this.$refs.fileMobile.files[0];
      const input = this.$refs.fileMobile;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthMobile = img.width;
            this.heightMobile = img.height;
          };
          img.src = e.target.result;
          this.urlMobile = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileDesktopJPG() {
      this.fileDesktopJPG = this.$refs.fileDesktopJPG.files[0];
      const input = this.$refs.fileDesktopJPG;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthDesktop = img.width;
            this.heightDesktop = img.height;
          };
          img.src = e.target.result;
          this.urlDesktopJPG = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobileJPG() {
      this.fileMobileJPG = this.$refs.fileMobileJPG.files[0];
      const input = this.$refs.fileMobileJPG;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthMobile = img.width;
            this.heightMobile = img.height;
          };
          img.src = e.target.result;
          this.urlMobileJPG = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileAppStore() {
      this.app_store_icon = this.$refs.app_store_icon.files[0];
      const input = this.$refs.app_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlAppStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFilePlayStore() {
      this.play_store_icon = this.$refs.play_store_icon.files[0];
      const input = this.$refs.play_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlPlayStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
